import TagsBar from './components/TagsBar'
import Tags, { TagsFragments } from './Tags'

export { TagsBar, TagsFragments }
export default Tags
